import View from '../app/View';

// Collection Header
import '../../components/collection/collection-header';
import '../../components/collection/collection-promobar';
import '../../components/collection/collection-title';
import SubCollectionMenu from '../../components/collection/sub-collection-menu';
import '../../components/collection/collection-secret-sale';

// Product Grid
import ProductGrid from '../../components/product-grid/product-grid';
import '../../components/product-grid/product-grid-header';
import Filter from '../../components/product-grid/filter';
import FilterClear from '../../components/product-grid/filter-clear';
import FilterCategory from '../../components/product-grid/filter-category';
import PriceFilter from '../../components/product-grid/price-filter';
import '../../components/product-grid/filter-option';
import '../../components/product-grid/active-filters';
import ActiveFilter from '../../components/product-grid/active-filter';
import Sort from '../../components/product-grid/sort';
import '../../components/product-grid/category-drawer';
import '../../components/product-grid/category-links';

// Pagination
import '../../components/global/pagination';

// Editorial Block
import '../../components/collection/editorial-block';

// Messaging Block
import '../../components/collection/collection-messaging-block';

// Collection Footer
import CollectionFooter from '../../components/collection/collection-footer';

// Collection Related Tags
import '../../components/collection/collection-related-tags';

// Collection Trending Articles
import CollectionTrendingArticles from '../../components/collection/collection-trending-articles';
import BlogArticleCard from '../../components/blog/blog-article-card';

// Collection FAQ
import CollectionFaq from '../../components/collection/collection-faq';
import '../../components/utility-faq-page/faq-drawer';

// Videos
import Video from '../../components/global/video';

// Three Card Module
import '../../components/collection/collection-three-card-module';
import LandingThreeCardModule from '../../components/landing-page-components/landing-three-card-module';
import LandingThreeCardModuleCard from '../../components/landing-page-components/landing-three-card-module-card';

// Hatbox Collections
import '../../components/collection/collection-hatbox-container';
import '../../components/collection/collection-hatbox-pane';
import CollectionHatboxNav from '../../components/collection/collection-hatbox-nav';
import CollectionHatboxGrid from '../../components/collection/collection-hatbox-grid';
import '../../components/collection/collection-hatbox-product-grid';

// Delivery Selection Collection
import '../../components/collection/collection-title-delivery-selection';
import CollectionDeliverySelectionForm from '../../components/collection/collection-delivery-selection-form';
import ZipcodeSearch from '../../components/delivery-selection/zipcode-search';
import '../../components/collection/collection-delivery-selection-date';

const pageView = new View();
pageView.init({
  // Add template specific components here
  ProductGrid,
  Filter,
  FilterClear,
  FilterCategory,
  PriceFilter,
  Sort,
  CollectionFooter,
  CollectionTrendingArticles,
  BlogArticleCard,
  CollectionFaq,
  LandingThreeCardModule,
  LandingThreeCardModuleCard,
  CollectionHatboxNav,
  CollectionHatboxGrid,
  CollectionDeliverySelectionForm,
  SubCollectionMenu,
  ZipcodeSearch,
});

const activeFilterView = new View();
activeFilterView.init({
  ActiveFilter,
});

const videoView = new View();
videoView.init({
  Video,
});

document.addEventListener('mountactivefilters', () => {
  activeFilterView.mountComponents();
});

document.addEventListener('mountvideos', () => {
  videoView.mountComponents();
});
